module.exports = __webpack_public_path__ + "66b67a7dbcdeac00736a793204928763.svg";